var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icons"},[_c('router-view',{attrs:{"sets":_vm.sets}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }